module.exports = __webpack_public_path__ + "media/images/logo-1cbe3e987baec2af496b19f7f89812d7.png";